import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MpSelfEnrolmentFormService } from '../mp-self-enrolment-form-service';
import { BaseButtonSizeEnum } from '../../../../../shared/components/base-button/base-button-size.enum';
import { TypeService } from '../../../../../../services/type/type-service';
import { BehaviorSubject, combineLatest, forkJoin, Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { MpSelfEnrolmentNavService } from '../mp-self-enrolment-nav-service';
import { Subscribable } from '../../../../../../models/base/subscribable';
import { PhoneDropdownItem } from '../../../../../../models/shared/phone-dropdown-item';

@Component({
  selector: 'app-mp-self-enrolment-contact-information',
  templateUrl: './mp-self-enrolment-contact-information.component.html',
  styleUrls: ['./mp-self-enrolment-contact-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MpSelfEnrolmentContactInformationComponent extends Subscribable implements OnInit {
  private formService = inject(MpSelfEnrolmentFormService);
  private navService = inject(MpSelfEnrolmentNavService);
  private typeService = inject(TypeService);

  public formSubmitted = false;
  public formGroup = this.formService.contactInfoForm;

  private _isLoading = new BehaviorSubject<boolean>(false);
  public isLoading$ = this._isLoading as Observable<boolean>;

  private _countryCodes = new BehaviorSubject<PhoneDropdownItem[]>([]);
  public countryCodes$ = this._countryCodes as Observable<PhoneDropdownItem[]>;

  public ngOnInit(): void {
    combineLatest([this.typeService.countriesAreLoaded$, this.typeService.countryCodesAreLoaded$])
      .pipe(
        take(1),
        tap(([countriesLoaded, codesLoaded]) => {
          if (!countriesLoaded || !codesLoaded) {
            this._isLoading.next(true);
          }
        }),
        switchMap(() => forkJoin([this.typeService.countries$, this.typeService.countryCodes$])),
        take(1)
      )
      .subscribe(([, codes]) => {
        this._countryCodes.next(codes);
        this._isLoading.next(false);
      });
  }

  public submit(): void {
    this.formSubmitted = true;
    if (this.formGroup.valid) {
      this.navService.goForward();
    }
  }

  public goBack(): void {
    this.navService.goBack();
  }

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
